import React, { useState } from "react";
import { Button } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useDispatch } from "react-redux";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import RadioGroupComponent from "components/atoms/RadioGroup";
import { useTranslation } from "react-i18next";

const UploadOptionsModal = ({ fileName = "", onConfirm }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Default selection: replace (same as Drive)
  const [uploadOption, setUploadOption] = useState("replace");

  const uploadOptions = [
    { value: "replace", label: t("modal.uploadOptions.replaceExistingFile") },
    { value: "keepBoth", label: t("modal.uploadOptions.keepBothFiles") },
  ];

  const handleUpload = () => {
    dispatch(closeCenterModal());
    onConfirm?.(uploadOption); // "replace" | "keepBoth"
  };

  return (
    <>
      <MuiBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          p: "24px",
        }}
      >
        <MuiTypography fontWeight="600" variant="20" color="text.darkBlack">
          {t("modal.uploadOptions.uploadOptions")}
        </MuiTypography>

        <MuiTypography fontWeight="400" variant="14" color="text.gray900">
          {t("modal.uploadOptions.fileAlreadyExistsDescription", { fileName })}
        </MuiTypography>

        <RadioGroupComponent
          options={uploadOptions}
          radioLabelColor={"text.darkBlack"}
          descriptionColor={"text.gray900"}
          isBold={true}
          value={uploadOption}
          onChange={(e) => setUploadOption(e.target.value)}
          rowgap={"16px"}
        />
      </MuiBox>

      <MuiBox
        sx={{
          display: "flex",
          gap: "12px",
          justifyContent: "end",
          backgroundColor: "background.gray200",
          p: "16px 24px",
        }}
      >
        <Button
          variant="whiteContained"
          onClick={() => dispatch(closeCenterModal())}
        >
          {t("commonButton.cancel")}
        </Button>
        <Button variant="blueContained" onClick={handleUpload}>
          {t("modal.uploadOptions.upload")}
        </Button>
      </MuiBox>
    </>
  );
};

export default UploadOptionsModal;
